var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8536 0.853553C16.0488 0.658291 16.0488 0.341709 15.8536 0.146447C15.6583 -0.0488155 15.3417 -0.0488155 15.1465 0.146447L12.438 2.85488C11.1188 1.69993 9.39113 1 7.5 1C3.35786 1 0 4.35786 0 8.5C0 12.6421 3.35786 16 7.5 16C11.4741 16 14.7263 12.909 14.9836 9H19.5C19.7762 9 20 8.77614 20 8.5C20 8.22386 19.7762 8 19.5 8H14.9836C14.872 6.30512 14.1975 4.76403 13.1451 3.56199L15.8536 0.853553ZM11.7291 3.56379C10.5923 2.58895 9.11495 2 7.5 2C3.91015 2 1 4.91015 1 8.5C1 12.0899 3.91015 15 7.5 15C10.9216 15 13.7257 12.3562 13.9811 9H7.50001C7.29778 9 7.11547 8.87818 7.03807 8.69134C6.96068 8.5045 7.00346 8.28945 7.14646 8.14645L11.7291 3.56379ZM13.9811 8H8.70712L12.4362 4.2709C13.3095 5.28925 13.8731 6.58094 13.9811 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolar);
export default __webpack_public_path__ + "static/media/polar.13cdd476f7845d7255e5d0f1b2b1f0d8.svg";
export { ForwardRef as ReactComponent };